import styled from 'styled-components';

import { Container } from '@sorare/core/src/atoms/layout/Container';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

export const SquadContentBlock = styled(Container).attrs({
  maxWidth: 600,
})`
  flex: 1;
  @media ${tabletAndAbove} {
    min-height: max(12vh, 400px);
    flex: none;
  }
`;

export const SquadFooter = styled(Container).attrs({
  maxWidth: 600,
})`
  padding: var(--double-unit) 0;
`;
